import { useEffect } from "react";
import { Drawer, DrawerOverlay, DrawerContent, DrawerHeader, DrawerBody, DrawerCloseButton, FormControl, Flex, DrawerFooter, FormLabel, Textarea } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import CustomButton from "../../../../components/Inputs/Button/customButton";
import { CategoryItem } from "./model";
import { HrlenseInput } from "../../../../components/Input/Input";
import { CustomToast } from "../../../../components";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: CategoryItem) => void;
  editData?: CategoryItem | null;
  //   categories: CategoryItem[];
}

const Category = ({ isOpen, onClose, onSave, editData }: Props) => {
  const { control, handleSubmit, reset, setValue, formState: { errors }, watch } = useForm<CategoryItem>({
    defaultValues: {
      name: "",
      description: "",
    },
  });

  const form = watch();
  const { addToast } = CustomToast();

  const onSubmit = (data: CategoryItem) => {
    if (!data.name || !data.name.trim()) {
      addToast({ message: "Category Name is required", status: "error" });
      return;
    }

    onSave(data);

    // addToast({
    //   message: editData
    //     ? "Category updated successfully"
    //     : "Category added successfully",
    //   status: "success",
    // });

    reset();
    onClose();
  };

  useEffect(() => {
    if (!isOpen) return;

    reset(
      editData
        ? {
          id: editData.id,
          name: editData.name,
          description: editData.description || "",
        }
        : { name: "", description: "" },
    );
  }, [isOpen, editData, reset]);

  const cancel = () => {
    reset();
    onClose();
  };

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={cancel} size="md">
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader> {editData ? "Edit Award Category" : "Add Award Category"} </DrawerHeader>

        <DrawerBody p={4}>
          <FormControl>
            <HrlenseInput isRequired label="Category Name" name="name" maxLength={100} control={control} errors={errors} />
          </FormControl>
          <FormControl mt={4}>
            <FormLabel>Description</FormLabel>
            <Textarea
              value={form.description}
              onChange={(e) => {
                if (e.target.value.length > 250) {
                  addToast({
                    message: "Description cannot exceed 250 characters",
                    status: "warning",
                  });
                  return;
                }
                setValue("description", e.target.value);
              }}
            />
          </FormControl>
        </DrawerBody>

        <DrawerFooter>
          <Flex mt={6} gap={3} justify="flex-end">
            <CustomButton className="btn_theme" title={editData ? "Update Category" : "Add Category"} onClick={handleSubmit(onSubmit)} />
            <CustomButton title="Cancel" onClick={cancel} />
          </Flex>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};

export default Category;
